import { useState } from "react";
import { useParams } from "react-router-dom";
import { useDocuments } from "@/hooks/useDocuments";
import { Modal } from "@/components/shared";
import ProjectShell from "../components/ProjectShell";
import DocumentUploadZone from "./components/DocumentUploadZone";
import DocumentList from "./components/DocumentList";
import EditDocumentModal from "./components/EditDocumentModal";
import type { DocumentRecord } from "./components/EditDocumentModal";

export default function ProjectUploads() {
  const { id } = useParams<{ id: string }>();
  const projectId = id!;
  const { documents, loading: documentsLoading, error: documentsError, refetch } = useDocuments({ projectId });
  const [editingDocument, setEditingDocument] = useState<DocumentRecord | null>(null);

  return (
    <ProjectShell projectId={projectId} activeTab="documents">
      <>
        {documentsError && (
          <p className="text-red-600 dark:text-red-400 mb-6">{documentsError.message}</p>
        )}

        <div className="space-y-8">
          <DocumentUploadZone projectId={projectId} onComplete={refetch} />

          <DocumentList
            documents={documents as unknown as DocumentRecord[]}
            projectId={projectId}
            onEdit={setEditingDocument}
            onDelete={refetch}
            loading={documentsLoading && documents.length === 0}
          />
        </div>

        <Modal
          isOpen={!!editingDocument}
          onClose={() => setEditingDocument(null)}
          title="Editar documento"
          maxWidth="max-w-lg"
        >
          <EditDocumentModal
            onClose={() => setEditingDocument(null)}
            document={editingDocument}
            projectId={projectId}
            onSaved={refetch}
          />
        </Modal>
      </>
    </ProjectShell>
  );
}
